import React, {Component} from 'react';
import {Form, Icon, message, Modal} from "antd";
import UploadWall from "../../../../components/upload/UploadWall";
import {
    ATTCHMENT_TYPE_ORIGINAL,
    AUDIO_TYPE_ORIGINAL,
    FILE_TYPE,
    PIC_TYPE_ORIGINAL,
    VIDEO_TYPE,
    VIDEO_TYPE_ORIGINAL,
    PIC_TYPE,
    AUDIO_TYPE
} from "../../../../constants";
import ChunkUpload from "../../../../components/upload/ChunkUpload";
import BaseComponent from "../../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import PictureNormalFileItem from "../../../../components/upload/fileItem/PictureNormalFileItem";
import VideoNormalFileItem from "../../../../components/upload/fileItem/VideoNormalFileItem";
import AudioNormalFileItem from "../../../../components/upload/fileItem/AudioNormalFileItem";
import OtherNormalFileItem from "../../../../components/upload/fileItem/OtherNormalFileItem";
import {converFileSize} from "../../../../utils";
import {systemBaseEvent} from "../../../../base/baseEvent";

class UploadFileItem extends Component{

    render() {

        // let {file} = this.props;
        //
        // let res = VIDEO_TYPE.find(item=>file?.originFileObj?.name.endsWith(item));
        // if(file.type.indexOf("image")>-1){
        //     return <PictureNormalFileItem key={file.md5} {...this.props} showEdit={false} />;
        // }else if(file.type.indexOf("video")>-1 ||res||VIDEO_TYPE.indexOf(file.ext)>-1){
        //     return <VideoNormalFileItem key={file.md5} {...this.props} showEdit={false} />;
        // }else if(file.type.indexOf("audio")>-1){
        //     return <AudioNormalFileItem key={file.md5} {...this.props} showEdit={false} />;
        // }else{
        //     return <OtherNormalFileItem key={file.md5} {...this.props} showEdit={false} />;
        // }


        let {file} = this.props;
        let show =false;
        if(file?.originFileObj?.name){
            show=true
        }

        if(show?PIC_TYPE.find(item=>file?.originFileObj?.name.endsWith(item)):PIC_TYPE.indexOf(file.ext)>-1){
            return <PictureNormalFileItem key={file.md5} {...this.props} showEdit={false} />;
        }else if(show?VIDEO_TYPE.find(item=>file?.originFileObj?.name.endsWith(item)):VIDEO_TYPE.indexOf(file.ext)>-1){
            return <VideoNormalFileItem key={file.md5} {...this.props} showEdit={false} />;
        }else if(show?AUDIO_TYPE.find(item=>file?.originFileObj?.name.endsWith(item)):AUDIO_TYPE.indexOf(file.ext)>-1){
            return <AudioNormalFileItem key={file.md5} {...this.props} showEdit={false} />;
        }else{
            return <OtherNormalFileItem key={file.md5} {...this.props} showEdit={false} />;
        }
    }
}
class UploadFile extends BaseComponent {

    static defaultProps = {
        showAddBtn: true,
        height: 280
    };

    constructor(props) {
        super(props);
        this.state={
            fileList:props.itemValue || [],
            maxSize: 1024 * 1024 * 1024 * 2  // 2GB
        }
    }

    componentWillMount() {
        systemBaseEvent.registerBaseEvent("addModalOnCancelOver", (data)=>{
            this.cancelUploadAll()
        });
    }

    checkData(){
        let {fileList} = this.state;
        for(let i = 0; i < fileList.length; i++){
            let file = fileList[i];
            if(!file.url){
                message.destroy();
                let name = file.name || file.originFileObj.name;
                message.warning(`${name}尚未上传完成，请等待所有文件上传完成！`);
                return false;
            }
        }
        return true;
    }

    beforeUpload = async file => {
        let res = FILE_TYPE.find(item=>file.name.endsWith(item));
        let sizeValue =  file.size;
        return new Promise((resolve, reject) => {
            if(res){
                if(sizeValue === 0) {
                    message.error(`空文件不能上传！`);
                    reject();
                }
                if(sizeValue < this.state.maxSize){
                    resolve()
                }else {
                    message.error(`文件大小不能超过${converFileSize(this.state.maxSize)}！`);
                    reject();
                }
            }else{
                // message.error(`${file.name}文件格式不正确，只能上传以下格式${FILE_TYPE.join("，")}`);
                message.error("暂不支持该文件类型！");
                reject();
            }
        });
    };
    chunkUpload = new ChunkUpload({
        checkFileURL:"/storage/checkFile",
        checkChunkURL:"/storage/checkChunk",
        uploadChunkURL:"/storage/uploadChunk",
        chunkUploadOverURL:"/storage/chunkIsUploadOver",
        mergeChunksURL:"/storage/mergeChunk",
        fileError:(md5, mergeResult, newFile)=>{
            Modal.error({
                title: '上传错误！',
                content: <div>文件  <span style={{color: 'red'}}>{mergeResult.name}</span>上传错误！</div>,
                onOk: () => {
                    let newFiles = this.state.fileList.filter(item=>item.md5 !== md5);
                    this.setState({fileList: newFiles},()=>{
                      
                        this.props.callBack&& this.props.callBack(this.state.fileList)
                    })
                }
            });
        },
        showError:true
    })

    cancelUploadAll = () => {
        if(typeof this.chunkUpload?.cancelUploadAll === 'function') {
            this.chunkUpload.cancelUploadAll()
        }
    }

    render() {
        //newFileType类型只有小写，没有大写
        let newFileType = [...VIDEO_TYPE_ORIGINAL, ...AUDIO_TYPE_ORIGINAL, ...PIC_TYPE_ORIGINAL, ...ATTCHMENT_TYPE_ORIGINAL]
        let {fileList} = this.state;
        // console.log(fileList,'fileList')
        return (
            <Form.Item label={this.props.label} required={this.props.empty} style={{display:"flex"}}>
                <Scrollbars autoHeight autoHeightMax={this.props.height}>
                    <UploadWall
                        showUploadDisplayBtn={true}
                        accept={"." + newFileType.join(",.")}
                        multiple={true}
                        action="/storage/uploadFile"
                        fileList={fileList}
                        style={{padding: "10px 0 0 0",width:"642px"}}
                        uploadBtnComponent={(size) => {
                            return <table style={{background: "#f4f6fc", border: "1px solid #f1f3f4", cursor: "pointer"}}
                                          cellSpacing={0} cellPadding={0} width={size} height={size}>
                                <tbody>
                                <tr>
                                    <td valign={"middle"} align={"center"}>
                                        <Icon type={"plus"}
                                              style={{color: "#5a5858", fontSize: 16, margin: 10}}/><br/>
                                        <span style={{color: "#9ca0a3", fontSize: 14}}>上传附件</span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        }}
                        customRequest={this.chunkUpload?.start}
                        icons={this.props.showAddBtn?["eye", "play", "download", "delete"]:[]}
                        fileItemComponent={UploadFileItem}
                        onEditFileNameCall={(file, fileName)=>{
                            this.state.fileList.forEach(item=>{
                                if(item.id === file.id) {
                                    item.name = fileName
                                }
                            });
                            this.setState({},()=>{
                                this.props.callBack && this.props.callBack(fileList)
                            });
                        }}
                        showUploadBtn={this.props.showAddBtn}
                        uploadBtnName={"上传附件"}
                        beforeUpload={this.beforeUpload}
                        onChange={this.handleChangeFileList}
                        onRemove={this.handleRemoveFileList}
                        onDownload={this.onDownload}
                    />
                </Scrollbars>
            </Form.Item>
        )
    }

    handleChangeFileList = (info) => {
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if(info.file.response && info.file.response.data){
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                    item.response = info.file.response;
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                let res = VIDEO_TYPE.find(item=>info.file?.originFileObj?.name.endsWith(item));
                if(item.type &&  item.type.indexOf("video")>-1||res) {
                    item.url = info.file.response && info.file.response.thumbnailsPlayPath;
                } else {
                    item.url = info.file.response && info.file.response.path;
                }
                item.path = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.isChunk = true;
                item.status = info.file.status;
                item.md5 = info.file.originFileObj && info.file.originFileObj.originalMd5;
                item.id = info.file.response && info.file.response._id;
            }
            return item;
        });
        this.setState({fileList: info.fileList},()=>{
            this.props.callBack&& this.props.callBack( info.fileList)
        });
    };

    handleRemoveFileList = file => {
        let fileList = this.state.fileList.filter(item => item.uid !== file.uid);
        this.setState({
            fileList
        },()=>{
            this.props.callBack&& this.props.callBack(fileList)
        });
    };

    onDownload = (file) => {
        console.log(file.path);
        if(file.path) {
            this.request({
                url: file.path+"?download=1",
                method: "downloadGet",
                contentType: "json",
            });
        } else {
            console.log("文件path丢失")
        }
    };
}

export default UploadFile;
